import type { Moment } from 'moment';
import moment from 'moment';

export function calculateAge(birthdate: Moment, targetDate: Moment = moment()): number {
  const ageInMilliseconds = targetDate.diff(birthdate);
  const ageInYears = moment.duration(ageInMilliseconds).asYears();
  return Math.floor(ageInYears);
}
